import { ready } from './vendor/brei-project-utils.js';

import { accordion } from './modules/accordion';
import { alert } from './modules/alert';
import { animator } from './modules/animator';
import { droplist } from './modules/droplist';
import { form } from './modules/form';
import { header } from './modules/header';
import { intro } from './modules/intro';
import { parallax } from './modules/parallax';
import { print } from './modules/print';
import { segment } from './modules/segment';
import { sliders } from './modules/sliders';
import { statCounter } from './modules/stat-counter';
import { table } from './modules/table';
import { video } from './modules/video';

const main = {
	init() {
		if(navigator.appVersion.indexOf('Android') > -1) { document.querySelector('html').classList.add('android'); }
		if(navigator.appVersion.indexOf('Win') > -1) { document.querySelector('html').classList.add('windows'); }
		
		// Structural
		form.init();
		segment.init();
		
		// Functional
		accordion.init();
		alert.init();
		droplist.init();
		header.init();
		print.init();
		table.init();		
		video.init();

		// Modular
		sliders.init();				
		
		// Presentational
		animator.init();
		intro.init();
		parallax.init();
		statCounter.init();
	}
};

ready(function () {
	main.init();
});
